import { render, staticRenderFns } from "./editNickName.vue?vue&type=template&id=6bab8c12&scoped=true&lang=html"
import script from "./editNickName.vue?vue&type=script&lang=js"
export * from "./editNickName.vue?vue&type=script&lang=js"
import style0 from "./editNickName.vue?vue&type=style&index=0&id=6bab8c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bab8c12",
  null
  
)

export default component.exports